import type { PropsWithChildren } from "react";
import { RbacProvider } from "@its-engineering-and-development/rbac-react";
import { createRbacTokenSource } from "@app/lib/auth/rbac-token-source";
import { rolePermissionMap } from "@app/lib/rbac/permissions";
import { StaticRoleResolver } from "@app/lib/rbac/static-role-resolver";

const rbacTokenSource = createRbacTokenSource();
const staticRoleResolver = new StaticRoleResolver(rolePermissionMap);

export function EventsAdminRbacProvider({ children }: PropsWithChildren) {
  return (
    <RbacProvider tokenSource={rbacTokenSource} resolver={staticRoleResolver}>
      {children}
    </RbacProvider>
  );
}
